import PaymentTitle from './PaymentTitle';

export default PaymentTitle;
